import { nanoid } from "nanoid"
import { create } from "zustand"
import { immer } from "zustand/middleware/immer"

import type { DataLayerStore, Events, DetailsRecord } from "./types"

export const useDataLayerStore = create<DataLayerStore>()(
  immer((set) => ({
    pendingEvents: [],

    addEvent: (event: Events, details: DetailsRecord) => {
      set((state) => {
        state.pendingEvents.push({
          id: nanoid(),
          event,
          details,
        })
      })
    },

    removeProcessedEvent: (id: string) => {
      set((state) => {
        state.pendingEvents = state.pendingEvents.filter(
          (event) => event.id !== id
        )
      })
    },
  }))
)
